import { FC, ReactNode } from "react";

export interface SectionPlaceholderProps {
    label: string | ReactNode;
}

export const SectionPlaceholder: FC<SectionPlaceholderProps> = ({
    label
}) => {
    return <div className="ucl-section-placeholder">{label}</div>;
}